import React, { useState } from "react";
import { Box, Typography, IconButton as MButton, FormLabel } from "@mui/material";
import {
    ThumbDown,
    ThumbDownOffAlt,
    ThumbDownOutlined,
    ThumbUp,
    ThumbUpOffAlt,
    ThumbUpOutlined,
} from "@mui/icons-material";
import DummyAgentImage from "../../../images/DummyAgent.svg";
import { s360ConfigService } from "../../Services/S360Config";

function NCXFormRateAgent(props) {
    const [userRatingThumbEmoji, setUserRatingThumbEmoji] = useState(-1);
    const fieldname = props?.field?.properties?.fieldname;

    const sharedStyle = {
        display: 'flex', 
        flexDirection: 'row', 
        alignItems: 'center', 
        justifyContent: 'space-evenly',
        gap: '4px'
    }

    const thumbClickType = Object.freeze({
        UP: "up",
        DOWN: "down",
    });

    function thumbRatingClicked(type) {
        setUserRatingThumbEmoji((prevRating) =>
          type === thumbClickType.UP
            ? prevRating === 1
              ? -1
              : 1
            : prevRating === 0
            ? -1
            : 0
        );
        props?.handleInputChange(
            fieldname, 
            type === thumbClickType.UP
                ? userRatingThumbEmoji === 1
                ? -1
                : 1
                : userRatingThumbEmoji === 0
                ? -1
                : 0, 
            props?.field
        )
    }

    const buttonSharedStyle = {
        
    }

    return (
        <Box key={props?.field._id} sx={{ marginBottom: "16px" }}>
            <FormLabel>{props?.field?.properties?.label}</FormLabel>
            <Box sx={{width: '100%', ...sharedStyle, border: '1px solid #bdbdbd', borderRadius: '4px', height: '4em', justifyContent: 'space-between', padding: '0 8px'}}>
                <Box sx={sharedStyle}>
                    <img src={DummyAgentImage} alt="" style={{ width: '40px', height: '40px' }} />
                    <Typography variant="body1" >{props?.agentInfo?.agentName || 'Support'}</Typography>
                </Box>
                <Box sx={sharedStyle}>
                    <MButton
                        onClick={() => thumbRatingClicked(thumbClickType.DOWN)}
                        size="large"
                        disabled={props?.field?.properties?.readOnly}
                    >
                        {
                            userRatingThumbEmoji === 0 ? (
                                <ThumbDown fontSize="large" color="error" />
                                ) : userRatingThumbEmoji === 1 ? (
                                <ThumbDownOffAlt fontSize="large" color="error" />
                                ) : (
                                <ThumbDownOutlined fontSize="large" sx={{ color: "black" }} />
                                )
                        }
                    </MButton>
                    <MButton
                        onClick={() => thumbRatingClicked(thumbClickType.UP)}
                        size="large"
                        disabled={props?.field?.properties?.readOnly}
                    >
                        {
                            userRatingThumbEmoji === 1 ? (
                                <ThumbUp fontSize="large" color="success" />
                                ) : userRatingThumbEmoji === 0 ? (
                                <ThumbUpOffAlt fontSize="large" color="success" />
                                ) : (
                                <ThumbUpOutlined fontSize="large" sx={{ color: "black" }} />
                                )
                        }
                    </MButton>
                </Box>
            </Box>
        </Box>
    )
}

export default NCXFormRateAgent